// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Result from "../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as MsisdnValidation from "../../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as CsvHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/csv-parser/CsvHelper.bs.js";
import * as ReMapUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ReMapUtils.bs.js";
import * as MobileNumberValidation from "../../../../../library/work-space/form/MobileNumberValidation.bs.js";

function validateRow(row, schema, country) {
  return Curry._2(ReMapUtils$Catalyst.StringMap.mapi, (function (key, validationType) {
                try {
                  var cellValue = Curry._2(ReMapUtils$Catalyst.StringMap.find, key, row);
                  switch (validationType) {
                    case /* String */0 :
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  TAG: /* String */0,
                                  _0: cellValue
                                }
                              };
                    case /* Number */1 :
                        try {
                          Caml_format.caml_int_of_string(cellValue);
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    TAG: /* Number */1,
                                    _0: cellValue
                                  }
                                };
                        }
                        catch (exn){
                          return {
                                  TAG: /* Error */1,
                                  _0: "invalid number"
                                };
                        }
                    case /* Msisdn */2 :
                        var match = MsisdnValidation.execute(cellValue, country);
                        if (match.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    TAG: /* Msisdn */2,
                                    _0: cellValue
                                  }
                                };
                        } else {
                          return {
                                  TAG: /* Error */1,
                                  _0: "invalid msisdn"
                                };
                        }
                    case /* Mobile */3 :
                        var match$1 = MobileNumberValidation.execute(cellValue, country);
                        if (match$1.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    TAG: /* Mobile */3,
                                    _0: cellValue
                                  }
                                };
                        } else {
                          return {
                                  TAG: /* Error */1,
                                  _0: "invalid mobile"
                                };
                        }
                    
                  }
                }
                catch (exn$1){
                  return {
                          TAG: /* Error */1,
                          _0: key + " not found in row"
                        };
                }
              }), schema);
}

function validateCsvRowAndMap(schema, entityMapper, country, csvRowList) {
  return {
          TAG: /* Ok */0,
          _0: List.map(entityMapper, List.map((function (row) {
                      return validateRow(row, schema, country);
                    }), csvRowList))
        };
}

function validateCsvResult(result, schema, entityMapper, country) {
  return Belt_Result.flatMap(CsvHelper$Catalyst.prepareCsvRows(result), (function (param) {
                return validateCsvRowAndMap(schema, entityMapper, country, param);
              }));
}

export {
  validateRow ,
  validateCsvRowAndMap ,
  validateCsvResult ,
  
}
/* CsvHelper-Catalyst Not a pure module */
